module.exports = __webpack_public_path__ + "e2e5e227454137963b3082453f82884d.png";